import React from 'react';

const HeroSection = ({ t, heroImage, onOpenConsultationForm }) => {
  const handleCTAClick = () => {
    onOpenConsultationForm();
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Elegant woman"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover"
          onError={(e) => { e.currentTarget.style.opacity = '0'; }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2C2C2C]/70 via-[#2C2C2C]/50 to-transparent"></div>
        {/* Fallback warm background in case image fails */}
        <div className="absolute inset-0 -z-10" style={{ background: 'linear-gradient(135deg, #2C2420 0%, #6B2737 100%)' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1
            className="text-5xl sm:text-6xl lg:text-7xl font-light text-[#FAF9F7] mb-6 leading-tight"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            {t.hero.title}
          </h1>
          <p className="text-lg sm:text-xl text-[#FAF9F7] mb-10 leading-relaxed max-w-2xl">
            {t.hero.subtitle}
          </p>
          <button
            onClick={handleCTAClick}
            className="group relative inline-flex items-center justify-center px-8 py-4 text-base font-medium tracking-wider uppercase text-white bg-[#8B4513] border-2 border-[#8B4513] rounded-md overflow-hidden transition-all duration-300 hover:bg-[#A0522D] hover:border-[#A0522D] hover:shadow-lg hover:-translate-y-1"
          >
            <span className="relative z-10">{t.hero.cta}</span>
          </button>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#FAF9F7] to-transparent"></div>
    </section>
  );
};

export default HeroSection;
